function headerScroll() {
  const header = document.querySelector('header');
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    // Always determine the scroll direction
    if (window.scrollY < lastScrollY) {
      // If scrolling up
      header.classList.add('scrolling-up');
      header.classList.remove('scrolling-down'); // Remove 'scrolling-down' when scrolling up
    } else {
      // If scrolling down and past 120 pixels
      if (window.scrollY >= 120) {
        header.classList.add('scrolling-down');
      }
      // Remove 'scrolling-up' class when scrolling down
      header.classList.remove('scrolling-up');
    }

    // If scrolled less than 120 pixels, remove classes
    if (window.scrollY < 120) {
      header.classList.remove('scrolling-down', 'scrolling-up');
    }

    // Update lastScrollY for the next invocation
    lastScrollY = window.scrollY;
  });
}

export default {
  init: function () {
    headerScroll();
  }
};
